var map = {
	"./WINE1.jpg": 87,
	"./WINE10.jpg": 88,
	"./WINE2.jpg": 89,
	"./WINE3.jpg": 90,
	"./WINE4.jpg": 91,
	"./WINE5.jpg": 92,
	"./WINE6.jpg": 93,
	"./WINE7.jpg": 94,
	"./WINE8.jpg": 95,
	"./WINE9.jpg": 96
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;